import { getAgentInfo } from '@/api/user'

const getDefaultState = () => {
  return {
    loaded: false, // 是否已请求过 agentInfo
    isAgent: false, // 当前账号是否为推广合伙人
    switchOn: false, // 平台总开关 agent_switch
    maxRatio: 80, // 下级分成比例上限 %
    subCount: 0 // 已绑定直接下级数
  }
}

const state = getDefaultState()

// 兼容后端可能返回 1 / '1' / true / 'true'
const toBool = (val) => val === true || val === 1 || val === '1' || val === 'true'

const mutations = {
  SET_AGENT_INFO(state, info) {
    state.isAgent = toBool(info.is_agent)
    state.switchOn = toBool(info.switch_on)
    state.maxRatio = Number(info.max_ratio) > 0 ? Number(info.max_ratio) : 80
    state.subCount = Number(info.sub_count) || 0
    state.loaded = true
  },
  RESET_AGENT_STATE(state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  // 登录后拉取合伙人信息；接口异常时不阻塞登录，默认非合伙人
  getAgentInfo({ commit }) {
    return getAgentInfo().then(res => {
      // 便于排查：控制台查看 /api/center/agentInfo 的原始返回
      console.log('[agentInfo] 原始返回：', res)
      // 兼容 {code,data:{...}} 与 {code,data:{data:{...}}}
      const info = (res && res.data && (res.data.is_agent !== undefined ? res.data : res.data.data)) || {}
      commit('SET_AGENT_INFO', {
        is_agent: info.is_agent,
        switch_on: info.switch_on,
        max_ratio: info.max_ratio,
        sub_count: info.sub_count
      })
      return res
    }).catch(err => {
      console.warn('[agentInfo] 请求失败：', err && err.message)
      commit('SET_AGENT_INFO', { is_agent: false, switch_on: false, max_ratio: 80, sub_count: 0 })
      return null
    })
  },
  resetAgentInfo({ commit }) {
    commit('RESET_AGENT_STATE')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
